import api, { handleApiError } from './client';

export const locationService = {
  /**
   * Get all locations
   */
  getAll: async (includeInactive = false) => {
    try {
      const response = await api.get('/api/locations', {
        params: { includeInactive }
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching locations:', error);
      return handleApiError(error, 'Errore nel caricamento delle stanze/location');
    }
  },

  /**
   * Get location by ID
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/api/locations/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching location:', error);
      return handleApiError(error, 'Errore nel caricamento della location');
    }
  },

  /**
   * Create location
   */
  create: async (data) => {
    try {
      const response = await api.post('/api/locations', data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error creating location:', error);
      return handleApiError(error, 'Errore nella creazione della location');
    }
  },

  /**
   * Update location
   */
  update: async (id, data) => {
    try {
      const response = await api.put(`/api/locations/${id}`, data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating location:', error);
      return handleApiError(error, 'Errore nell\'aggiornamento della location');
    }
  },

  /**
   * Delete or deactivate location
   */
  delete: async (id) => {
    try {
      const response = await api.delete(`/api/locations/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error deleting location:', error);
      return handleApiError(error, 'Errore nell\'eliminazione della location');
    }
  }
};
